class NotificationsDelegate {
    setLoading(loading) {
        this.setState({ loading });
    }

    setNotifications(notifications) {
        this.setState({ notifications });
    }

    setFilteredNotifications(filteredNotifications) {
        this.setState({ filteredNotifications });
    }

    setStats(stats) {
        this.setState({ stats });
    }
}

export default NotificationsDelegate;

